<template>
  <div class="warning" style="padding: 0 1em; text-align: left; min-height: 20em;">
    請注意~無可執行功能
  </div>
</template>

<script>
export default {
  name: 'warning',
  data () {
    return {
      content: ''
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    }
  },
  created () {
    // console.log('== Warning ==')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
